import styled from '@emotion/styled';
import { Link } from '@hotjar/hotsauce';
import { FilterKindEnum } from '../../../../domains/global-filters/model/FilterChain';
import { getFilterMetadata } from '../../FilterChainUtils';
import { LargeListFilterFactory } from '../LargeListFilterFactory';

const StyledLink = styled(Link)`
  white-space: nowrap;
`;

export const EventFilter = LargeListFilterFactory(
  getFilterMetadata(FilterKindEnum.Event),
  'Enter an event name...',
  <span>
    Sessions with custom user actions (such as conversions) that you tracked with our{' '}
    <StyledLink
      kind="inline"
      href="https://help.hotjar.com/hc/en-us/articles/4405109971095"
      isExternal
    >
      Events API
    </StyledLink>
  </span>,
);
